let modular_grid_unit

export function setModularGridUnit(unit)
{
	modular_grid_unit = unit
}

export function getModularGridUnit()
{
	return modular_grid_unit
}